import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { elevatedSurfaceBoxShadow, transition } from '../style-settings'

export const useLabeledSelectStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapperRoot: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      alignSelf: 'flex-start',
    },
    wrapperFluid: {
      width: '100%',
      minWidth: 0,
      [theme.breakpoints.up('md')]: {
        width: 'auto',
        minWidth: 100,
      },
    },
    fieldLabel: {
      display: 'block',
      width: '100%',
      fontSize: '0.8rem',
      fontWeight: 600,
      color: theme.palette.text.secondary,
      textAlign: 'left',
      marginBottom: theme.spacing(0.1),
    },
    formControl: {
      width: '100%',
      margin: 0,
      '& .MuiOutlinedInput-root': {
        minHeight: 42,
        boxSizing: 'border-box',
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.palette.divider}`,
        transition: transition,
        '& fieldset': {
          border: 'none',
        },
        '&:hover': {
          backgroundColor: theme.palette.common.white,
          borderColor: theme.palette.primary.main,
        },
        '&.Mui-focused': {
          backgroundColor: theme.palette.common.white,
          borderColor: theme.palette.primary.main,
          boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
        },
      },
      '& .MuiSelect-select': {
        display: 'flex',
        alignItems: 'center',
        minHeight: 42,
        boxSizing: 'border-box',
        padding: theme.spacing(0, 2),
        paddingRight: theme.spacing(4),
      },
    },
    menuPaper: {
      borderRadius: theme.shape.borderRadius * 2,
      boxShadow: elevatedSurfaceBoxShadow,
    },
    menuItem: {
      minHeight: 42,
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
    },
  })
)
